import React from 'react';

import { VerificationRequestFormContext } from 'src/providers/VerificationRequestFormProvider';

export const useVerificationRequestFormData = () => {
  return React.use(VerificationRequestFormContext);
};
